<template>
  <div>
    <div v-if="error">
      <server-error :error="error" />
    </div>
    <div v-if="isLoaded && error == null ">
      <div class="pt-4">
        <AlternativeContractEdit
          :prevRoute="prevRoute"
          :currentContract="editContract"
          @onClickEditCardData="openEditCardData"
          @onClickEditPeriodSpendings="openEditPeriodSpendings"
          @onClickEditLowValueAssets="openEditLowValueAssets"
          @onClickSaveEditContract="saveAltContract"
        ></AlternativeContractEdit>
      </div>
      <popup name="alt-contract-data-popup" height="auto" :scrollable="true">
        <AltCardDataPopup
          :contract="editContract"
          @onSaveEditing="saveCardDataEditing"
          @close="onCloseEditCardData"
        ></AltCardDataPopup>
      </popup>
      <popup name="alt-contract-period-spendings-popup" height="auto" :scrollable="true">
        <AltPeriodSpendingsPopup
          :periodSpendings="editContract.periodSpendings"
          @onSaveEditing="savePeriodSpendingsEditing"
          @close="onCloseEditPeriodSpendings"
        ></AltPeriodSpendingsPopup>
      </popup>
      <popup name="alt-contract-low-value-assets-popup" height="auto" :scrollable="true">
        <AltLowValueAssetsPopup
          :lowValueAssets="editContract.lowValueAssets"
          @onSaveEditing="saveLowValueAssetsEditing"
          @close="onCloseEditLowValueAssets"
        ></AltLowValueAssetsPopup>
      </popup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AlternativeContractEdit from "../components/registry/alternativeContracts/edit/AlternativeContractEdit";
import AltCardDataPopup from "../components/registry/alternativeContracts/edit/rawEditing/AltCardDataPopup";
import AltPeriodSpendingsPopup
  from "../components/registry/alternativeContracts/edit/rawEditing/AltPeriodSpendingsPopup";
import AltLowValueAssetsPopup from "../components/registry/alternativeContracts/edit/rawEditing/AltLowValueAssetsPopup";

export default {
  data() {
    return {
      error: null,
      isEditCardData: false,
      isEditPeriodSpendings: false,
      isEditLowValueAssets: false,
      editContract: null,
      prevRoute: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.fullPath;
    })
  },
  components: {
    AltPeriodSpendingsPopup,
    AlternativeContractEdit,
    AltLowValueAssetsPopup,
    AltCardDataPopup
  },
  async created() {
    this.$store.commit("SET_ALT_CONTRACT_CHANGE_CONDITION_STATE", false);
    let currentContactId = this.$route.params.id;

    try {
      this.error = null;
      this.$loadingManager.addLoadingStep(1);
      await this.$store.dispatch("getAlternativeContractById", currentContactId);

      await Promise.all([
        this.$store.dispatch("getAllCounterparties"),
				this.$store.dispatch('loadContractSettings'),
        this.$store.dispatch("loadAllUnderlyingAssetTypes"),
        this.$store.dispatch('loadAllBusinessUnits'),
        this.$store.dispatch("loadAllAssets"),
      ]);
      this.$loadingManager.loadingStepLoaded();
    } catch (e) {
      this.$loadingManager.hideLoadScreen();
      this.error = e;
    }

    this.editContract = _.cloneDeep(this.currentAlternativeContract);
  },
  computed: {
    ...mapGetters(["getCurrentAlternativeContract"]),
    currentAlternativeContract() {
      return this.getCurrentAlternativeContract;
    },
  },
  methods: {
    openEditCardData() {
      this.isEditCardData = true;
      this.$modal.show('alt-contract-data-popup');
    },
    openEditPeriodSpendings() {
      this.isEditPeriodSpendings = true;
      this.$modal.show('alt-contract-period-spendings-popup');
    },
    openEditLowValueAssets() {
      this.isEditLowValueAssets = true;
      this.$modal.show('alt-contract-low-value-assets-popup');
    },
    saveCardDataEditing(cardData) {
      for (let prop in cardData) {
        if (
          cardData.hasOwnProperty(prop) &&
          cardData[prop] !== this.editContract[prop]
        ) {
          this.editContract[prop] = cardData[prop];
        }
      }
      this.editContract.lessorIds =
        cardData.lessorIds;
    },
    onCloseEditCardData() {
      this.isEditCardData = false;
      this.$modal.hide('alt-contract-data-popup');
    },
    savePeriodSpendingsEditing(periodSpendings) {
      this.editContract.periodSpendings = periodSpendings;
    },
    onCloseEditPeriodSpendings() {
      this.isEditPeriodSpendings = false;
      this.$modal.hide('alt-contract-period-spendings-popup');
    },
    saveLowValueAssetsEditing(lowValueAssets) {
      this.editContract.lowValueAssets = lowValueAssets;
    },
    onCloseEditLowValueAssets() {
      this.isEditLowValueAssets = false;
      this.$modal.hide('alt-contract-low-value-assets-popup');
    },
    async saveAltContract() {
      try {
        const currentContactId = this.$route.params.id;
        await this.$store.dispatch("updateAltContract", {
          contractId: currentContactId,
          data: this.editContract
        });
        this.$store.commit("SET_ALT_CONTRACT_CHANGE_CONDITION_STATE", false);
      } catch (e) {
        this.error = e;
        this.editContract = this.currentAlternativeContract;
      }

      this.$store.commit("SET_ALT_CONTRACT_CHANGE_CONDITION_STATE", false);
    },
  }
};
</script>
